<template>
    <div class="simple-form">
        <div class="form-group center">
            <div class="form-label">
                <label>机构名称</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.name || '' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>机构编号</label>
            </div>
            <div class="form-value">
                <span>{{ comInfo.no || '' }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>机构类型</label>
            </div>
            <div class="form-value">
                <span>{{ orgTypeMap[comInfo.orgType] || '' }}</span>
            </div>
        </div>
        <div class="form-group center" v-if="comInfo.orgType == 1">
            <div class="form-label">
                <label class="required">业务单元类型</label>
            </div>
            <div class="form-value width-2x">
                <span>{{ bizUnitTypeMap[comInfo.bizUnitType] }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>业务单元级别</label>
            </div>
            <div class="form-value">
                <div class="value">{{ getTransComLevel(comInfo.bizUnitLevel)}}</div>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>机构地址</label>
            </div>
            <div class="form-value">
                <span>{{comInfo.regionName || ''}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>详细地址</label>
            </div>
            <div class="form-value">
                <span>{{comInfo.street || ''}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>联系人姓名</label>
            </div>
            <div class="form-value width-2x">
                <span>{{comInfo.contactName || ''}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>联系电话</label>
            </div>
            <div class="form-value width-2x">
                <span>{{comInfo.contactTel || ''}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>联系电子邮箱</label>
            </div>
            <div class="form-value width-2x">
                <span>{{comInfo.contactEmail || ''}}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>实体公司编码</label>
            </div>
            <div class="form-value width-2x">
                <span>{{comInfo.realComCode || ''}}</span>
            </div>
        </div>
        <div class="form-group center spacing">
            <div class="form-label">
                <label>机构图片</label>
            </div>
            <div class="form-value">
                <div v-if="files != null" class="file-area clearfix">
                    <swb-file-item disabled v-for="(file, index) in files" :trackKey="index" :fileUuid="file.fileUuid" :fileBrowseUrl="file.fileBrowseUrl"></swb-file-item>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {Utils} from '../../app.base'
    import {Vue, MsgBox} from '../../app.vues'
    import {transComLevel} from './struct-comn';

    import servicerApi from '../../api/servicer'

    export default {
        name: 'swb-servicer-com-detail',
        desc: '机构信息-详情',
        props: {
            comId: {
                type: Number,
                default: null
            }
        },
        data: function () {
            return {
                orgTypeMap: getEnumMap('orgType', 'value2text'),
                bizUnitTypeMap: getEnumMap('bizUnitType', 'value2text'),
                comInfo: {},
                files: []
            }
        },
        created: function () {
            this.getComInfo();
        },
        methods: {
            getTransComLevel: function (level) {
                return transComLevel(level);
            },
            getComInfo: function () {
                let self = this;
                let postData = {
                    comId: self.comId
                };
                let theLoad = MsgBox.loading();
                servicerApi.getServicerCom(postData, function (result) {
                    theLoad.close();
                    if (result.type == 'info') {
                        let comInfo = result.data || {};
                        //
                        let headUuid = comInfo.headUuid;
                        if(!Utils.isNoB(headUuid)) {
                            let fileList = [];
                            let file = {};
                            file.fileUuid = headUuid;
                            file.fileBrowseUrl = comInfo.fileBrowseUrl;
                            fileList.add(file);
                            self.files = fileList;
                        } else {
                            self.files = null;
                        }
                        self.comInfo = Utils.merge({}, comInfo);
                    } else if (result.type == 'error') {
                        MsgBox.error(result.message, result.errid);
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/orgStruct/ComDetail.vue